import { apiMutate, getApiErrorMessage, isApiError } from "~/utils/apiClient";

const { VITE_CATALOG_API } = import.meta.env;

export interface PromoteDatasetTableRequest {
  source: {
    table_name: string;
    drop_after_promote: boolean;
  };
  destination: {
    dataset_id: string;
    table_name: string;
    schema_name: string;
    overwrite_if_exists: boolean;
  };
}

/**
 * Promote a table out of the caller's personal dataset into a dataset they own,
 * via the dedicated POST /v1/users/me/dataset/tables/promote endpoint.
 */
export const promoteDatasetTable = async (request: PromoteDatasetTableRequest): Promise<void> => {
  try {
    await apiMutate(`${VITE_CATALOG_API}/v1/users/me/dataset/tables/promote`, "POST", request);
  } catch (e) {
    throw new Error(isApiError(e) ? getApiErrorMessage(e) : "Unable to promote table");
  }
};
